import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["preview", "deleteButton", "dropzone"];

  connect() {}

  removeFile(event) {
    event.preventDefault();
    const name = this.previewTarget.dataset.formParamName;

    // Hide the preview and remove hidden field value

    delete this.previewTarget.dataset.attached;
    this.setHiddenFieldWithNullValue(name);
  }


  setHiddenFieldWithNullValue(name) {
    this.hiddenInput = document.createElement("input");
    this.hiddenInput.type = "hidden";
    this.hiddenInput.name = name;
    this.hiddenInput.value = "";
    this.previewTarget.appendChild(this.hiddenInput);
  }
}
